import React from 'react';
import PropTypes from 'prop-types';

import {
    NODE_NAME_ATTENDING,
    NODE_NAME_FIRST_NAME,
    NODE_NAME_LAST_NAME,
    NODE_NAME_EMAIL,
    NODE_NAME_ADDITIONAL_GUEST_FIRST_NAME,
    NODE_NAME_ADDITIONAL_GUEST_LAST_NAME,
    NODE_NAME_ADDITIONAL_GUEST_EMAIL,
    NODE_NAME_ADDITIONAL_GUEST_TOP_GROUP,
    NODE_NAME_CHECK_IN,
    NODE_NAME_CHECK_OUT,
    NODE_NAME_CAPTCHA,
    NODE_NAME_SOCIAL_RSVP,
    NODE_NAME_DATE_RANGE,
    NODE_NAME_DATE_RANGE_START_DATE,
    NODE_NAME_DATE_RANGE_END_DATE,
    NODE_NAME_DATE_RANGE_START_TIME,
    NODE_NAME_DATE_RANGE_END_TIME,
} from 'common/entities/formNode/nodeNames';
import {
    NODE_TYPE_ROOT,
    NODE_TYPE_GROUP,
    NODE_TYPE_QUESTION,
    NODE_TYPE_QUESTION_MULTIPLE,
    NODE_TYPE_CONTENT,
} from 'common/entities/formNode/nodeTypes';

import { INPUT_TYPE_EVENT_OPS_2, INPUT_TYPE_EVENT_OPS_RESOURCE } from 'common/entities/formNode/inputTypes';

import FormEditorEditRoot from './FormEditorEditRoot';
import FormEditorEditGroup from './FormEditorEditGroup';
import FormEditorEditQuestion from './FormEditorEditQuestion';
import EditQuestionAttending from './EditQuestionAttending';
import EditQuestionAdditionalGuestCount from './EditQuestionAdditionalGuestCount';
import EditQuestionGuestInfoField from './EditQuestionGuestInfoField';
import EditQuestionAdditionalGuestInfoField from './EditQuestionAdditionalGuestInfoField';
import EditContentNode from './EditContentNode';
import CheckInOutEditView from './CheckInOutEditView';
import EventOpsEditView from './EventOpsResources/EventOpsEditView';
import EventOps2EditView from './EventOps2/EventOps2EditView';
import SocialRsvp from './SocialRsvp';
import DateRange from './DateRange';
import DateRangeChild from './DateRange/DateRangeChild';

/** @var {Object} - edit view components for question per input type */
const INPUT_TYPE_VIEWS = {
    [INPUT_TYPE_EVENT_OPS_2]: EventOps2EditView,
    [INPUT_TYPE_EVENT_OPS_RESOURCE]: EventOpsEditView,
    default: FormEditorEditQuestion,
};

/** @var {Object} - generic edit view components per node type */
const EDIT_VIEW_TYPES = {
    [NODE_TYPE_ROOT]: () => FormEditorEditRoot,
    [NODE_TYPE_GROUP]: () => FormEditorEditGroup,
    [NODE_TYPE_QUESTION]: (formNodeInputType) => INPUT_TYPE_VIEWS[formNodeInputType] || INPUT_TYPE_VIEWS.default,
    [NODE_TYPE_QUESTION_MULTIPLE]: (formNodeInputType) =>
        INPUT_TYPE_VIEWS[formNodeInputType] || INPUT_TYPE_VIEWS.default,
    [NODE_TYPE_CONTENT]: () => EditContentNode,
    default: () => null,
};

/** @var {Object} - specific edit view components per node name */
const QUESTION_COMPONENTS_BY_NAME = {
    [NODE_NAME_FIRST_NAME]: EditQuestionGuestInfoField,
    [NODE_NAME_LAST_NAME]: EditQuestionGuestInfoField,
    [NODE_NAME_EMAIL]: EditQuestionGuestInfoField,
    [NODE_NAME_ADDITIONAL_GUEST_FIRST_NAME]: EditQuestionAdditionalGuestInfoField,
    [NODE_NAME_ADDITIONAL_GUEST_LAST_NAME]: EditQuestionAdditionalGuestInfoField,
    [NODE_NAME_ADDITIONAL_GUEST_EMAIL]: EditQuestionAdditionalGuestInfoField,
    [NODE_NAME_ATTENDING]: EditQuestionAttending,
    [NODE_NAME_ADDITIONAL_GUEST_TOP_GROUP]: EditQuestionAdditionalGuestCount,
    [NODE_NAME_CHECK_IN]: CheckInOutEditView,
    [NODE_NAME_CHECK_OUT]: CheckInOutEditView,
    [NODE_NAME_CAPTCHA]: React.Fragment,
    [NODE_NAME_SOCIAL_RSVP]: SocialRsvp,
    [NODE_NAME_DATE_RANGE]: DateRange,
    [NODE_NAME_DATE_RANGE_START_DATE]: DateRangeChild,
    [NODE_NAME_DATE_RANGE_END_DATE]: DateRangeChild,
    [NODE_NAME_DATE_RANGE_START_TIME]: DateRangeChild,
    [NODE_NAME_DATE_RANGE_END_TIME]: DateRangeChild,
};

const FormEditorEditContent = ({ formNodeType, formNodeName, formNodeInputType }) => {
    const Component =
        QUESTION_COMPONENTS_BY_NAME[formNodeName] ||
        (EDIT_VIEW_TYPES[formNodeType] && EDIT_VIEW_TYPES[formNodeType](formNodeInputType)) ||
        EDIT_VIEW_TYPES.default;
    return <Component />;
};

FormEditorEditContent.propTypes = {
    formNodeType: PropTypes.string,
    formNodeName: PropTypes.string,
    formNodeInputType: PropTypes.string,
};
FormEditorEditContent.defaultProps = {
    formNodeType: '',
    formNodeName: '',
    formNodeInputType: '',
};

export default FormEditorEditContent;
